import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCalendarChecked20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCalendarChecked20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.5 1.75a.75.75 0 0 0-1.5 0V2H4.5A2.5 2.5 0 0 0 2 4.5v11A2.5 2.5 0 0 0 4.5 18h11a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 15.5 2H14v-.25a.75.75 0 0 0-1.5 0V2h-5zm5 2.5V3.5h-5v.75a.75.75 0 0 1-1.5 0V3.5H4.5a1 1 0 0 0-1 1v2h13v-2a1 1 0 0 0-1-1H14v.75a.75.75 0 0 1-1.5 0m-9 11.25V8h13v7.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1m4.28-4.03a.75.75 0 0 0-1.06 1.06l1.631 1.632.53.53.531-.53 3.536-3.535a.75.75 0 0 0-1.061-1.061L8.882 12.57z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCalendarChecked20);
